import { SensorModelConfiguration } from '../types';

/**
 * Configuration du modèle MILESIGHT CT101
 * Capteur de température et humidité
 */
export const MILESIGHT_CT101: SensorModelConfiguration = {
  brand: 'MILESIGHT',
  model: 'CT101',
  metrics: {
    current: {
      type: 'number',
      unit: 'A',
      icon: 'BoltIcon',
      color: 'info.main',
      labelRef: 'current'
    },
    total_current: {
      type: 'number',
      unit: 'A',
      icon: 'BoltIcon',
      color: 'info.main',
      labelRef: 'total_current'
    }
  }
};
